export default __webpack_public_path__ + "static/sm-poster02-3f668f0e49efcf79f23dfd2aedc3a253.png";